{
  "name": "factos-frontend",
  "version": "1.0.49",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:deploy": "ng build && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "typecheck": "tsc --noEmit -p tsconfig.app.json",
    "test": "ng test --watch=false",
    "lint": "eslint \"src/**/*.ts\"",
    "lint:fix": "eslint \"src/**/*.ts\" --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss,css,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss,css,json}\"",
    "local_dev": "ng serve --port 4201",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org aleia-health --project factos-frontend ./dist && sentry-cli sourcemaps upload --org aleia-health --project factos-frontend ./dist"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.2.0",
  "dependencies": {
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@sentry/angular": "^10.65.0",
    "@sentry/cli": "^2.58.6",
    "@tailwindcss/forms": "^0.5.11",
    "@tailwindcss/postcss": "^4.1.18",
    "echarts": "^6.1.0",
    "lucide-angular": "^0.563.0",
    "marked": "^18.0.5",
    "ngx-echarts": "^21.0.0",
    "pdfjs-dist": "^6.2.108",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.18",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.2",
    "@angular/cli": "^21.1.2",
    "@angular/compiler-cli": "^21.1.0",
    "@types/node": "^26.1.1",
    "@typescript-eslint/eslint-plugin": "^8.54.0",
    "@typescript-eslint/parser": "^8.54.0",
    "eslint": "^9.39.2",
    "eslint-plugin-prettier": "^5.5.5",
    "jsdom": "^29.1.1",
    "postcss": "^8.5.6",
    "prettier": "^3.8.1",
    "typescript": "~5.9.2",
    "vitest": "^4.1.12"
  }
}
